var o = {};
var rParam;
var orgParam;
var orgCode = "RF10260000";
var apiKey = "f7adc993-eb50-4eec-aa19-477ef680cf1f";

//var orgCode = "DF10250000";
//var apiKey = "1a90bbfa-34a7-47c8-90c7-411a65eeda92";

import util from "@/common/util";
import { reactive, inject, onMounted, ref, nextTick } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import deferred from "vue-deferred";
import axios from "@/axios";

async function finCertAuth() {
  var defer = deferred();

  var result = await axios.json("/mobAth/genFncNonce.do");

  //금융인증서 로그인을 위한 난수생성
  var nonce = result.data.FNC_NONCE;

  var finParam = {};
  var signData = "금융인증서 본인인증";

  if ("01" == orgParam.type) {
    signData = signData + "등록";
  } else if ("02" == orgParam.type) {
    signData = signData + "삭제";
  }

  finParam.signFormat = {};
  finParam.signFormat.type = "CMS";

  finParam.signFormat.CMSInfo = {};
  finParam.signFormat.CMSInfo.ssn = "dummy";
  finParam.signFormat.CMSInfo.withoutContent = false;
  finParam.signFormat.CMSInfo.generalSyntax = true;
  finParam.signFormat.CMSInfo.includeR = true;

  var plainTexts = new Array();
  plainTexts[0] = signData + "&FNC_NONCE=" + nonce;

  finParam.content = {};
  finParam.content.plainText = {};
  finParam.content.plainText.plainTexts = plainTexts;
  finParam.content.plainText.encoding = "UTF-8";

  finParam.algorithm = "RSASSA-PKCS1-v1_5_SHA256";

  /*
					 * 사용자 전자서명 거래 종류
						'01' : 로그인, 회원관리
						'02' : 송금 (이체, 자동송금관리 등)
						'03' : 금융상품가입/해지 (예적금, 대출, 보험, 펀드 등)
						'04' : 전자계약체결/해지 (근로, 공급, 용역, 거래, 각종 동의서 등)
						'05' : 납부/결제 (자동납부관리, 공과금 납부, 카드대금 결제 등)
						'06' : 증명서발급 
						'07' : 자산연동 (오픈뱅킹, 마이데이터 등)
						'08' : 인증수단관리 (인증서, 보안매체 폐지 등), 보안설정 (비밀번호 변경 등)
						'11' : 로그인 (증권)
						'12' : 본인확인
						'99' : 기타
					 */
  finParam.info = {};
  finParam.info.signType = "01";

  finParam.success = function(result) {
    defer.resolve(result);
  };
  finParam.fail = function(result) {
    defer.reject(result);
  };

  FinCert.Sdk.sign(finParam);

  return defer.promise;
}

export default {
  auth: (param) => {
    var defer = deferred();

    orgParam = param;
    orgParam.cmAthDivCd = "01"; // 본인인증

    try {
      var scriptElem = document.createElement("script");
      var dt = new Date();
      var today = util.formatDate(dt, "yyyymmdd");

      scriptElem.src = "https://4user.yeskey.or.kr/v1/fincert.js?dt=" + today;
      scriptElem.id = "finCertSdk";

      scriptElem.onload = function() {
        FinCert.Sdk.init({
          orgCode: orgCode,
          apiKey: apiKey,
          lang: "kor",
          success: function() {
            defer.resolve(finCertAuth());
          },
          fail: function(error) {
            defer.reject(error);
          },
        });
      };

      document.querySelector("body").appendChild(scriptElem);
    } catch (e) {
      if (e.message == "FinCert is not defined") {
        alert(
          "금융결제원과 통신이 원활하지 않습니다.<br/>다른 인증수단으로 진행해주세요.<br>이용에 불편을 드려 죄송합니다."
        );
      } else {
        alert(e.message);
      }

      defer.reject(error);
    }

    return defer.promise;
  },
};
